<div>
    <div class="double-list">
        <app-dsi-management-list (onDsiChange)="onDsiChange($event)"
                                 [userApplications]="userApplications"></app-dsi-management-list>
        <app-application-management-list [selectedDsi]="selectedDsi"
                                         [userApplications]="userApplications"></app-application-management-list>
    </div>

</div>
